module.exports = __webpack_public_path__ + "img/title.9ceb64ff.png";